import './index.erb';
import './index.rb';

import {handleApiError} from 'utils/api_error_handler';


export default class QuestionLikes {
  constructor(context) {
    this.$likeButton = $('.js-like-comment-btn', context);

    this.bindAll()
  }

  bindAll() {
    this._bindLike();
  }

  _bindLike() {
    this.$likeButton
      .off('click.question_comment_like')
      .on('click.question_comment_like', e => this.like(e));
  }

  like(e) {
    const data = e.currentTarget.dataset;
    const id = parseInt(data.id);
    const resourceId = parseInt(data.resourceId);
    const $likeBtn = $(e.currentTarget);

    Thor.Commentary
      .update_like({id, question_id: resourceId})
      .then((e) => {
        const $likes = $likeBtn.find('.js-likes');
        const numberOfLikes = e.commentary.likes;
        $likes.html(numberOfLikes);
        $likeBtn.toggleClass('btn-liked');
      })
      .catch(({response}) => {
        handleApiError('Ops! Parece que aconteceu algum erro!', response);
      });
  }
}
